<script setup lang="ts">
import { EntityListPage, type EntityConfig } from '@botto/core';
import { directionsStore } from '../../api';
import type { Direction } from '../../api';

const config: EntityConfig<Direction> = {
  title: 'Направление',
  titlePlural: 'Направления',
  popupWidth: 560,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'name', caption: 'Название' },
    { dataField: 'country_iso', caption: 'ISO', width: 80 },
    { dataField: 'operator', caption: 'Оператор' },
    { dataField: 'carrier_codes', caption: 'Коды операторов' },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'name', label: 'Название', required: true },
    { dataField: 'country_iso', label: 'ISO страны', required: true },
    { dataField: 'operator', label: 'Оператор' },
    { dataField: 'carrier_codes', label: 'Коды операторов', required: true, editorType: 'dxTextArea' },
  ],
};
</script>

<template>
  <EntityListPage :config="config" :store="directionsStore" />
</template>
